import channels, { Channel } from '@root/modules/channel/config/channel.config';
import { Data } from '@root/modules/issue/types/issue';
import matchChannel from '@root/common/utils/matchChannel';
import getAliasByLocale from '@root/common/utils/getAliasByLocale';

type BuildIssueUrl = ({
  issue,
  locale,
  domain,
  fakeDomainEnabled,
}: {
  issue: Data;
  locale: string;
  domain?: string | string[];
  fakeDomainEnabled?: boolean;
}) => string;

function buildIssueDevUrl(issue: Data, channelConfig: Channel) {
  const channelDomain = channelConfig.domain;
  const channelParam = channelDomain ? `?site=${channelDomain}` : '';
  const origin = process.client ? document.location.origin : '';
  const path = getAliasByLocale(channelConfig.locale, 'issue');

  // Example of builded urls
  // if old_type_redirects_dev === true 'https://ekspress.delfi.ee/leht/90228785'
  // if old_type_redirects_dev === false '/issue/90228785?site=ekspress.delfi.ee'
  return channelConfig.old_type_redirects_dev ? `${channelConfig.url}/${path}/${issue.id}` : `${origin}/${path}/${issue.id}${channelParam}`;
}

function buildIssueLiveUrl(issue: Data, channelConfig: Channel) {
  const isTest = typeof window === 'undefined' ? process.env.CHANNEL_CONFIG_ENV === 'test' : /.test.delfi/.test(document.location.hostname);
  const domain = isTest ? channelConfig.domain.replace('.delfi', '.test.delfi') : channelConfig.domain;
  const path = getAliasByLocale(channelConfig.locale, 'issue');
  return channelConfig.old_type_redirects ? `https://${domain}/${path}/${issue.id}` : `https://${domain}/${path}/${issue.id}`;
}

// Build dev or live issue url
const buildIssueUrl: BuildIssueUrl = ({ issue, locale, domain, fakeDomainEnabled }) => {
  const { channel } = issue;
  const sameChannel = domain ? matchChannel(domain, channel.domain) : true;
  const path = getAliasByLocale(locale, 'issue');

  let issueUrl = `/${path}/${issue.id}`;

  if (!sameChannel) {
    // TODO: Change after Content-api channel object will return channel url
    const channelConfig = channels.find((ch) => ch.domain === channel.domain) || null;

    if (channelConfig) {
      const isDev = fakeDomainEnabled;
      issueUrl = isDev ? buildIssueDevUrl(issue, channelConfig) : buildIssueLiveUrl(issue, channelConfig);
    } else {
      throw Error;
    }
  }
  return issueUrl;
};

export default buildIssueUrl;
